<template>
  <div class="service-config">
    <Store ref="storeRef" :storeIds="formData.storeIds" v-bind="$attrs" />
    <SignCompany
      ref="signCompanyRef"
      :enterpriseId="formData.enterpriseId"
      :cooperationPlatform="formData.cooperationPlatform"
      :cooperationPlatformNames="formData.cooperationPlatformNames"
      v-bind="$attrs"
      class="white-bg"
    />
  </div>
</template>

<script setup>
import { cloneDeep } from 'lodash'
import { ref, watch } from 'vue'
import SignCompany from './components/SignCompany/index.vue'
import Store from './components/Store/index.vue'
import { useEditFormState } from './hooks/useEditFormState'
import { useFormValidation } from './hooks/useFormValidation'

const { validate: validateForm } = useFormValidation()
const { state: formState } = useEditFormState()

const props = defineProps({
  serviceInfoVO: {
    type: Object,
    default: () => ({}),
  },
})

const storeRef = ref(null)
const signCompanyRef = ref(null)
const formData = ref({})

watch(
  () => props.serviceInfoVO,
  (n, o) => {
    if (n === o || !n) return
    formData.value = cloneDeep(n)
  },
  {
    immediate: true,
  },
)

watch(
  [() => formState.value.modelId, () => formState.value.cityCode],
  ([newModelId, newCityCode], [oldModelId, oldCityCode]) => {
    if (
      (newModelId !== oldModelId && oldModelId !== null) ||
      (newCityCode !== oldCityCode && oldCityCode !== null)
    ) {
      formData.value.storeIds = []
      formData.value.enterpriseId = null
      formData.value.cooperationPlatform = []
    }
  },
  {
    deep: true,
  },
)

const validate = () => {
  const validateTasks = [
    { ref: storeRef, name: 'store' },
    { ref: signCompanyRef, name: 'signCompany' },
  ]

  return validateForm(validateTasks)
}
const preStoreValidate = () => {
  const validateTasks = []

  return validateForm(validateTasks)
}

defineExpose({
  validate,
  preStoreValidate,
  getData: () => {
    return {
      storeIds: storeRef.value.getData(),
      enterpriseId: signCompanyRef.value.getData()?.enterpriseId,
      cooperationPlatform: signCompanyRef.value.getData()?.cooperationPlatform,
      state: 1,
    }
  },
})
</script>

<style lang="scss" scoped>
.service-config {
  width: 100%;
  margin: 0 auto;
}

.white-bg {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
}

.add-question {
  text-align: center;
  padding: 20px;
}
</style>
